import { render, staticRenderFns } from "./utp.vue?vue&type=template&id=549d7ff4&scoped=true"
import script from "./utp.vue?vue&type=script&lang=js"
export * from "./utp.vue?vue&type=script&lang=js"
import style0 from "./utp.vue?vue&type=style&index=0&id=549d7ff4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549d7ff4",
  null
  
)

export default component.exports